import Card from '@/components/Card/Card';

export default {
  name: 'Forbidden',
  components: {
    Card
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
